import { Fragment } from 'react';

import { VIEW_DATE_WITH_TIME_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import Text, { TextImportance } from 'bloko/blocks/text';
import VSpacing from 'bloko/blocks/vSpacing';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import EmployerLink from 'components/Admin/Invoices/InvoicesTable/Invoice/Account/EmployerLink';
import TableBody from 'components/Table/TableBody';
import TableCell from 'components/Table/TableCell';
import TableRow from 'components/Table/TableRow';

import { InvoicePayerType } from 'store/models/invoices';
import { useSelector } from 'store/utils';

const PayerAttributes = () => {
    const { payer, payerId } = useSelector((state) => state.payerDetail);
    const trl = useTrls();

    const { userId, hhid, employerId, email, userName, dateLastUpdate, billingDetails } = payer;

    return (
        <Table fullWidth withStripes bordered>
            <TableBody>
                <TableRow>
                    <TableCell>
                        <Text strong>{trl('admin.Users.User.id')}</Text>
                    </TableCell>
                    <TableCell>{userId}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <Text strong>{trl('admin.Payers.Payer.payerId')}</Text>
                    </TableCell>
                    <TableCell>{payerId}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <Text strong>{trl('admin.Users.User.hhID')}</Text>
                    </TableCell>
                    <TableCell>{hhid}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <Text strong>{trl('admin.Users.User.employerID')}</Text>
                    </TableCell>
                    <TableCell>
                        <EmployerLink employerId={employerId} />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <Text strong>{trl('admin.Users.User.email')}</Text>
                    </TableCell>
                    <TableCell>{email}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <Text strong>{trl('admin.Users.User.name')}</Text>
                    </TableCell>
                    <TableCell>{userName}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <Text strong>{trl('admin.Payers.Payer.requisites')}</Text>
                    </TableCell>
                    <TableCell>
                        {billingDetails.payer !== InvoicePayerType.Natural ? (
                            <Fragment>
                                {billingDetails.title}
                                <Text importance={TextImportance.Secondary}>
                                    {trl('admin.Invoices.InvoicesTable.Invoice.Requisites.address', [
                                        billingDetails.address,
                                    ])}
                                </Text>
                                <VSpacing base={2} />
                                <Text importance={TextImportance.Secondary}>
                                    {trl('admin.Invoices.InvoicesTable.Invoice.Requisites.post', [billingDetails.post])}
                                </Text>
                                <VSpacing base={2} />
                                <Text importance={TextImportance.Secondary}>
                                    {trl('admin.Invoices.InvoicesTable.Invoice.Requisites.inn', [billingDetails.inn])}
                                </Text>
                                {billingDetails.kpp && (
                                    <Fragment>
                                        <VSpacing base={2} />
                                        <Text importance={TextImportance.Secondary}>
                                            {trl('admin.Invoices.InvoicesTable.Invoice.Requisites.kpp', [
                                                billingDetails.kpp,
                                            ])}
                                        </Text>
                                    </Fragment>
                                )}
                            </Fragment>
                        ) : (
                            billingDetails.fio
                        )}
                    </TableCell>
                </TableRow>

                <TableRow>
                    <TableCell>
                        <Text strong>{trl('admin.PayerDetail.lastUpdate')}</Text>
                    </TableCell>
                    <TableCell>
                        <p>{formatDate(dateLastUpdate, VIEW_DATE_WITH_TIME_FORMAT)}</p>
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};

export default PayerAttributes;
